module.exports = __webpack_public_path__ + "media/images/badge/supercoppa-bracket-perfetto_secondary-7c0393bc820e2badc29d503a661812a8.png";